import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import {
  TYPE_NEW_ORDER,
  TYPE_DELIVER_ORDER,
  TYPE_CANCEL_NEW_ORDER,
  TYPE_CANCEL_DELIVER_ORDER,
  STATUS_IN_PROGRESS,
} from '@chama/utils/constants/status';
import ActionsDeliverOrder from './DeliverOrder';
import ActionsNewOrder from './NewOrder';
import ActionsCancelNewOrder from './CancelNewOrder';
import ActionsCancelDeliverOrder from './CancelDeliverOrder';
import './index.css';

const propTypes = {
  isBeingProcessed: PropTypes.bool.isRequired,
  isLoadingAssignment: PropTypes.bool.isRequired,
  startDelivery: PropTypes.func.isRequired,
  declineOrder: PropTypes.func.isRequired,
  deliverOrder: PropTypes.func.isRequired,
  cancelOrder: PropTypes.func.isRequired,
  dismissCancelNewOrder: PropTypes.func.isRequired,
  dismissCancelDeliverOrder: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  assignedToUserId: PropTypes.string,
  isAssignedToCurrentUser: PropTypes.bool.isRequired,
};

const defaultProps = {
  assignedToUserId: undefined,
};

const ActionButtons = props => {
  const {
    startDelivery,
    declineOrder,
    deliverOrder,
    cancelOrder,
    dismissCancelNewOrder,
    dismissCancelDeliverOrder,
    isBeingProcessed,
    isLoadingAssignment,
    type,
    status,
    isAssignedToCurrentUser,
    assignedToUserId,
    order,
  } = props;
  const isLoading = !isAssignedToCurrentUser || isLoadingAssignment || isBeingProcessed;
  const orderIsInAppPayment = order.paymentType === 'inAppPayment';
  if (status === STATUS_IN_PROGRESS && !isAssignedToCurrentUser && assignedToUserId) {
    const isChamaUser = assignedToUserId.indexOf('chama') !== -1;
    const getUserId = () => {
      if (isChamaUser) {
        return <FormattedMessage id="chama_team" defaultMessage="the Chama team" />;
      }

      return assignedToUserId;
    };
    const wrapperClass = classNames('OrderDetailsLayout__aleady_assigned_wrapper', {
      'OrderDetailsLayout__aleady_assigned_wrapper--chama_team': isChamaUser,
    });

    return (
      <div className={wrapperClass}>
        <FormattedMessage id="hey_it_seems_that" defaultMessage="Hey, it seems that" />
        &nbsp;
        {getUserId()}
        &nbsp;
        <FormattedMessage
          id="is_already_taking_care_of_this_order"
          defaultMessage="is already taking care of this order."
        />
      </div>
    );
  }

  if (type === TYPE_NEW_ORDER) {
    return (
      <ActionsNewOrder
        startDelivery={startDelivery}
        declineOrder={declineOrder}
        isLoading={isLoading}
        canAcceptOrder={!orderIsInAppPayment}
      />
    );
  }

  if (type === TYPE_DELIVER_ORDER) {
    return (
      <ActionsDeliverOrder
        deliverOrder={deliverOrder}
        cancelOrder={cancelOrder}
        isLoading={isLoading}
      />
    );
  }

  if (type === TYPE_CANCEL_NEW_ORDER) {
    return <ActionsCancelNewOrder dismissOrder={dismissCancelNewOrder} isLoading={isLoading} />;
  }

  if (type === TYPE_CANCEL_DELIVER_ORDER) {
    return (
      <ActionsCancelDeliverOrder dismissOrder={dismissCancelDeliverOrder} isLoading={isLoading} />
    );
  }

  return null;
};

ActionButtons.propTypes = propTypes;
ActionButtons.defaultProps = defaultProps;

export default ActionButtons;



// WEBPACK FOOTER //
// ../ui-components/components/ActionButtons/index.jsx